<template>
  <div class="mb-3">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-md-12">
                <h3 class="mb-0">Add Bulk Inventory</h3>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <base-input label="Item Code" required>
                      <a-select
                        class="w-100"
                        v-model="formData.code"
                        @change="onChangeCode"
                        :disabled="viewMode || itemData != null"
                      >
                        <a-select-option
                          v-for="item in options.codes"
                          v-bind:value="item.id"
                          v-bind:key="item.id"
                        >
                          {{ item.code }}
                        </a-select-option>
                      </a-select>
                      <div v-if="$v.formData.code.$dirty" class="text-danger">
                        <div class="error" v-if="!$v.formData.code.required">
                          Field is required
                        </div>
                      </div>
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <base-input label="Item Description">
                      <a-input
                        v-model.trim="formData.description"
                        :disabled="true"
                      />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <a
                      href="#"
                      class="btn btn-primary btn-sm"
                      @click="downloadTemplate"
                    >
                      Generate Template
                    </a>
                  </div>
                </div>
                <div class="row pt-2">
                  <div class="col">
                    <h6 class="heading-small text-muted">
                      <span class="text-danger">*</span> Upload File
                    </h6>
                    <div class="input-group mb-3">
                      <div class="custom-file">
                        <a-input
                          placeholder="Member Name"
                          v-model="formData.csv"
                          type="file"
                          accept=".csv"
                          class="custom-file-input"
                          id="inputGroupFile01"
                          @change="handleFileChange"
                        />
                        <label
                          class="custom-file-label"
                          for="inputGroupFile01"
                          >{{ selectedFileName }}</label
                        >
                      </div>
                    </div>
                    <div v-if="$v.formData.csv.$dirty" class="text-danger">
                      <div class="error" v-if="!$v.formData.csv.required">
                        Field is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end">
                  <div class="p-1">
                    <b-button
                      size="sm"
                      class="float-md-left"
                      style="margin-left: 8px"
                      @click.prevent="closeDrawer"
                    >
                      Cancel
                    </b-button>
                  </div>
                  <div class="p-1">
                    <b-button
                      size="sm"
                      @click="confirmAdjustment"
                      variant="success"
                    >
                      <b-spinner v-if="submitLoading" small></b-spinner>
                      Import
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import secureStorage from '../../controllers/secureStorage';
import { Modal } from 'ant-design-vue';

export default {
  name: 'BulkInventoryForm',
  props: {
    itemData: Object,
    viewMode: Boolean,
    type: String,
    drawerVisible: Boolean
  },
  components: {},
  data() {
    return {
      selectedFileName: 'Choose file',
      searchLoading: false,
      submitLoading: false,
      query: null,
      querySuccess: false,
      transactionFlag: false,
      sites: [],
      memberData: {
        firstname: '',
        lastname: '',
        membershipProgramId: '',
        membershipLevelId: '',
        currentPointsBalanceExpiring: 0,
        currentPointsBalanceActive: 0
      },
      formData: {
        code: null,
        description: null,
        csv: null,
        data: null
      },
      options: {
        codes: []
      }
    };
  },

  validations: {
    formData: {
      code: { required },
      csv: { required }
    }
  },

  methods: {
    closeDrawer() {
      this.resetData();
      this.$emit('closeDrawer', null);
    },
    onChangeCode(data) {
      const item = this.options.codes.find((item) => item.id === data);
      if (item) {
        this.formData.description = item.description;
      }
    },
    confirmAdjustment() {
      Modal.confirm({
        title: 'Confirm',
        content:
          'This will import site inventories into the system. Are you sure you want to proceed?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => {
          this.onSubmit();
        },
        onCancel: () => {}
      });
    },
    validateCsvHeaders(headers) {
      const requiredHeaders = ['site_code', 'site_name', 'area', 'inventory'];
      for (const header of requiredHeaders) {
        if (!headers.includes(header)) {
          return false;
        }
      }
      return true;
    },
    handleFileChange(event) {
      const fileInput = event.target;
      if (fileInput.files.length > 0) {
        const selectedFile = fileInput.files[0];
        this.selectedFileName = selectedFile.name;

        const reader = new FileReader();
        reader.onload = (e) => {
          const contents = e.target.result;
          const lines = contents.split('\n');
          if (lines.length > 0) {
            const headers = lines[0].split(',').map((header) => header.trim());
            if (!this.validateCsvHeaders(headers)) {
              this.selectedFileName = 'Choose file';
              this.formData.csv = null;
              this.$notification.error({
                message:
                  'Missing header on uploaded file.CSV headers must include site_name, area, and inventory.'
              });
              return;
            }
          }
        };
        this.formData.data = selectedFile;
        reader.readAsText(selectedFile);
      } else {
        this.selectedFileName = 'Choose file';
      }
    },
    downloadTemplate() {
      let csvContent = 'site_code,site_name,area,inventory\n';
      for (const site of this.sites) {
        let siteCode = site.code || '';
        siteCode = '="' + siteCode + '"';
        const siteName = site.name || '';
        const area = site.area || '';
        csvContent += `${siteCode},${siteName},${area},\n`;
      }

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'Bulk Inventory Template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    async getSites() {
      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.sites = response.data.sort((a, b) => a.name.localeCompare(b.name));
    },
    moment,
    setTransactionFlag(el) {
      const positiveFlag = el.item.$el.dataset.positiveFlag == 1 ? true : false;
      this.transactionFlag = positiveFlag;
    },

    async onSubmit() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.submitLoading = true;
        const formData = new FormData();
        formData.append('code', this.formData.code);
        formData.append('description', this.formData.description);
        formData.append('csv', this.formData.data);
        const response = await HTTPRequest.postRequest(
          '/api/v1/site_item_inventories/bulk_append?origin_site_id=' +
            secureStorage.getItem('currentSiteId'),
          formData,
          secureStorage.getItem('bxiClpAccessToken'),
          'multipart/form-data'
        );

        if (response.message != undefined && response.message == 'Success') {
          this.$emit('closeDrawer', null);
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Import completed.'
          });

          this.resetData();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submitLoading = false;
      }
    },

    async getItems() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_items?status_code=A',
        {
          per_page: 1000
        }
      );
      this.options.codes = response.data.sort((a, b) =>
        a.code.localeCompare(b.code)
      );
    },

    resetData() {
      this.formData = {
        code: null,
        description: null,
        csv: null,
        data: null
      };
      this.selectedFileName = 'Choose file';
      this.query = null;
      this.querySuccess = false;
      this.$v.formData.$reset();
    }
  },

  created() {
    this.getItems();
    this.getSites();
  },

  watch: {
    itemData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>

<style scoped></style>
